import * as React from 'react';

var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDeleteOutline16 = function SvgDeleteOutline16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.677 2v.5h2.265c.335 0 .559.251.559.5v2.214h-.706v9.12c0 .616-.54 1.166-1.265 1.166H4.47c-.724 0-1.265-.55-1.265-1.167V5.214H2.5V3c0-.249.224-.5.56-.5h2.263V1c0-.249.224-.5.559-.5h4.235c.335 0 .559.251.559.5v1z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.177 2.5h1.764c.335 0 .559.251.559.5v2.214h-11V3c0-.249.224-.5.559-.5h8.117zM3.2 5.214h9.6",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6 7.429v5.714M8 7.429v5.714m2.4-5.714v5.714",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
};

var DeleteOutline16Svg = SvgDeleteOutline16;

export { DeleteOutline16Svg as default };
//# sourceMappingURL=DeleteOutline16.svg.js.map
